export default "__VITE_ASSET__BlqfUE$q__"